import { render } from "./CreatePageCategory.vue?vue&type=template&id=743e8132"
import script from "./CreatePageCategory.vue?vue&type=script&lang=js"
export * from "./CreatePageCategory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__